const navigationLinks = [
    { path: "/", name: "Home" },
    { path: "/athletes", name: "Athletes" },
    { path: "/achievements", name: "Achievements" },
    { path: "/news", name: "News" },
    { path: "/about", name: "About" }
];

export default navigationLinks;
